import getOffer from '@utils/getOffer';
// eslint-disable-next-line import/prefer-default-export
export const useOffer = (): string[] => {
  const [offer, priceList, storage] = getOffer();

  return [offer, priceList, storage];
};
